"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleDateKeyPress = void 0;

var date_fns_1 = require("date-fns");

var setPreviousDay = function setPreviousDay(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var previousDay = (0, date_fns_1.subDays)(selectedDate, 1);
  setSelectedDate(previousDay);
};

var setNextDay = function setNextDay(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var nextDay = (0, date_fns_1.addDays)(selectedDate, 1);
  setSelectedDate(nextDay);
};

var setPreviousWeek = function setPreviousWeek(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var previousWeek = (0, date_fns_1.subWeeks)(selectedDate, 1);
  setSelectedDate(previousWeek);
};

var setNextWeek = function setNextWeek(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  var nextWeek = (0, date_fns_1.addWeeks)(selectedDate, 1);
  setSelectedDate(nextWeek);
};

var setDatePreviousMonth = function setDatePreviousMonth(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.subMonths)(selectedDate, 1));
};

var setDateNextMonth = function setDateNextMonth(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.addMonths)(selectedDate, 1));
};

var setDatePreviousYear = function setDatePreviousYear(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.subYears)(selectedDate, 1));
};

var setDateNextYear = function setDateNextYear(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.addYears)(selectedDate, 1));
};

var setMonthStart = function setMonthStart(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.startOfMonth)(selectedDate));
};

var setMonthEnd = function setMonthEnd(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate;
  setSelectedDate((0, date_fns_1.endOfMonth)(selectedDate));
};

var handleDateKeyPress = function handleDateKeyPress(_a) {
  var selectedDate = _a.selectedDate,
      setSelectedDate = _a.setSelectedDate,
      event = _a.event,
      onSelectDate = _a.onSelectDate;
  var key = event.key,
      shiftKey = event.shiftKey;
  var state = {
    selectedDate: selectedDate,
    setSelectedDate: setSelectedDate
  };

  switch (key) {
    case 'Enter':
      onSelectDate(selectedDate);
      return;

    case ' ':
      onSelectDate(selectedDate);
      return;

    case 'PageUp':
      shiftKey ? setDatePreviousYear(state) : setDatePreviousMonth(state);
      return;

    case 'PageDown':
      shiftKey ? setDateNextYear(state) : setDateNextMonth(state);
      return;

    case 'End':
      setMonthEnd(state);
      return;

    case 'Home':
      setMonthStart(state);
      return;

    case 'ArrowLeft':
      setPreviousDay(state);
      return;

    case 'ArrowUp':
      setPreviousWeek(state);
      return;

    case 'ArrowRight':
      setNextDay(state);
      return;

    case 'ArrowDown':
      setNextWeek(state);
      return;

    default:
      return;
  }
};

exports.handleDateKeyPress = handleDateKeyPress;